import { render, staticRenderFns } from "./newpositions.vue?vue&type=template&id=076e9d00&scoped=true&"
import script from "./newpositions.vue?vue&type=script&lang=js&"
export * from "./newpositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076e9d00",
  null
  
)

export default component.exports